import script from "./ModalValidarPartida.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalValidarPartida.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__